<template>
    <FullFillBox
        :pageID="this.getPageID"
        :otherPer="[9, 10]"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.add === 1){
                this.showAddButton = true
            }
            if(data.edit === 1){
                this.showEditButton = true
            }
            if(data.delete === 1){
                this.showDeleteButton = true
            }
        }"
        @otherPermission="(data) => {
            if(data[0].status === 80){
                this.exportButtonCanSpawn = true
            }
            if(data[1].status === 80){
                this.uploadButtonCanSpawn = true
            }
        }"
    >
        <div v-if="!doneLoading">{{ $t('common_loading') }}</div>
        <div v-if="!wrongParams">
            <h5>{{ title }}</h5>
            <div class="row" v-if="getType === 'location' || getType === 'driver' || getType === 'department'">
                <div class="col-md-6 gy-1">
                    <button class="btn btn-primary"
                            v-if="exportButtonCanSpawn"
                            @click="getServerExcelExport">
                        {{ $t('common_export_excel') }}
                    </button>
                </div>
                <div class="col-md-6 gy-1">
                    <button class="btn btn-primary"
                            v-if="uploadButtonCanSpawn"
                            @click="getServerExcelUpload">
                        {{ excelUpload }}
                    </button>
                </div>
            </div>
            <div ref="tabulatorTableUse" id="table"></div>
            <button class="btn btn-primary"
                    @click="openEditPopUpMenu('add', 0)"
                    v-if="showAddButton"
                    style="margin: 10px auto 10px auto;width: 200px">
                {{ $t('common_add') }}
            </button>
        </div>
        <div v-if="doneLoading && wrongParams">
            <h3 style="color: red">{{ $t('error_not_found') }}</h3>
        </div>
    </FullFillBox>

    <!--   PopupMenu Open Printer Setting List  -->
    <vue-final-modal v-model="showEditPopUp" classes="modal-container" content-class="modal-content"
                     style="margin-top: 20vh;margin-right: 5%;margin-left: 5%;height: 10px">
        <button class="modal__close" @click="closeEditPopUp">
            <i class="bi bi-x-lg"></i>
        </button>
        <span class="modal__title"></span>
        <div class="modal__content" style="background-color: white;border: black solid 3px;height: auto;width: auto">
            <OtherDetailsEditPopUp
                :mode="mode"
                :popUpType="popUpType"
                :popUpRowHeaders="popUpRowHeaders"
                :popUpReturnData="popUpReturnData"
                :permissionToDelete="this.showDeleteButton"
                @reloadNow="reloadNow"
            />
        </div>
    </vue-final-modal>

</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import OtherDetailsEditPopUp from "@/components/OtherDetailsEditPopUp";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "OtherDetailsProcessView",
    components: {
        FullFillBox,
        OtherDetailsEditPopUp,
    },
    data(){
        return{
            permissionDetails: {},
            uploadButtonCanSpawn: false,
            exportButtonCanSpawn: false,
            showDeleteButton: false,
            showEditButton: false,
            showAddButton: false,
            getPageID: 0,
            title: '',
            doneLoading: false,
            wrongParams: false,
            getType: '',
            returnData: '',
            rowHeaders: '',

            // words may change
            excelUpload: '',

            // pop up menu
            mode: '',
            showEditPopUp: false,
            popUpType: '',
            popUpRowHeaders: '',
            popUpReturnData: '',
        }
    },
    watch: {
        '$route.params': {
            async handler(newType) {
                this.title = newType.type.charAt(0).toUpperCase() + newType.type.slice(1);
                let dataList = {
                    "location": 1016,
                    "category": 1017,
                    "brand": 1018,
                    "size": 1019,
                    "color": 1020,
                    "material": 1021,
                    "unit": 1022,
                    "department": 1023,
                    "driver": 1024,
                }
                this.getPageID = dataList[newType.type]
                document.title = this.$t('title') + ' | ' + this.title
                await this.processType(newType.type)
                this.getType = newType.type
                this.wordProcessOnExcelButton(newType.type)
            },
            immediate: true,
        }
    },
    methods: {
        async getServerExcelUpload(){
            this.$router.push(`/other-details/import/${this.getType}`)
        },
        async getServerExcelExport(){
            await this.$mainApi.get(`api/other-details/export?type=${this.getType}`)
                .then(response => {
                    if(response.data.status === 80){
                        location.href = (this.$store.state.serverIp + response.data.details)
                    }else{
                        console.log(response.data)
                        this.$toast.warning(this.$t('error_excel_export'))
                    }
                })
        },
        wordProcessOnExcelButton(getType){
            if(getType === 'location'){
                this.excelUpload = this.$t('other_details_location_excel_upload')
            }else if(getType === 'driver'){
                this.excelUpload = this.$t('other_details_driver_excel_upload')
            }else if(getType === 'department'){
                this.excelUpload = this.$t('other_details_department_excel_upload')
            }
        },
        async reloadNow(getType){
            this.closeEditPopUp()
            await this.getBackendData(getType)
        },
        async openEditPopUpMenu(mode, getRowID){
            this.mode = mode
            if(mode === 'add'){
                this.popUpRowHeaders = this.rowHeaders
                // create empty value dict
                let returnEmptyDict = {}
                for(let i=0;i<this.rowHeaders.length;i++){
                    // ID will be set in backend
                    if(i === 0){
                        returnEmptyDict[this.rowHeaders[i]] = "N/A"
                        // Last Item will be Flag, default as Show (1)
                    }else if(i === this.rowHeaders.length-1){
                        returnEmptyDict[this.rowHeaders[i]] = "1"
                        // Others Data will be empty
                    }else{
                        returnEmptyDict[this.rowHeaders[i]] = ""
                    }
                }
                this.popUpReturnData = returnEmptyDict
                this.popUpType = this.getType
                this.showEditPopUp = true
                this.$store.commit('setIsBlackLayout', true)
            }else{
                await this.$mainApi.get(`api/other-details/single-processor?type=${this.getType}&id=${getRowID}`)
                    .then(response => {
                        if(response.data.status === 80){
                            this.popUpType = response.data.details.type
                            this.popUpRowHeaders = response.data.details.rowHeaders
                            this.popUpReturnData = response.data.details.returnData[0]
                            this.showEditPopUp = true
                            this.$store.commit('setIsBlackLayout', true)
                        }
                    })
            }
        },
        closeEditPopUp(){
            this.$store.commit('setIsBlackLayout', false)
            this.showEditPopUp = false
        },
        tableSetup(getHeaders, data){
            let new_column = []
            for(let i=0;i<getHeaders.length;i++){
                let header = getHeaders[i]
                new_column.push({
                    title: header, field: header, sorter: i === 0 ? "number" : "string", resizable: false,
                    responsive: 0,
                    headerFilter: i === 0 ? "input" : "list",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                    formatter: (cell, formatterParams, onRendered) => {
                        if(i === getHeaders.length-1){
                            if(cell.getValue() === 1){
                                // True
                                return "<span style='color: #2563EB'>" + this.$t('common_show') + "</span>"
                            }else{
                                return "<span style='color: #eb2525'>" + this.$t('common_hide') + "</span>"
                            }
                        }else{
                            return cell.getValue()
                        }
                    },
                })
            }
            new_column.push({
                formatter: () => {
                    return "<i class='bi bi-pencil-fill'></i>"
                },
                headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                headerMenu: this.getHeaderMenu,
                headerSort: false, width: 10, responsive: 0,
                cellClick: (e, row, formatterParams) => {
                    if(this.showEditButton){
                        this.openEditPopUpMenu("update", row.getData().id)
                    }else{
                        this.$toast.error(this.$t('error_no_permission'))
                    }
                }
            })

            this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
                placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                data: data,
                columns: new_column,
                reactiveData: true, //enable data reactivity
                maxHeight: '90vh',
                responsiveLayout: 'collapse',
                layout: "fitColumns",
                movableColumns: true,
                movableRows: false,
                initialSort: [
                    {column: "id", dir: "asc"},
                ],
            })
        },
        async processType(type) {
            this.wrongParams = false
            let checkList = ['category', 'brand', 'size', 'color', 'material', 'unit', 'driver', 'location','department']
            if (type !== undefined) {
                if (checkList.includes(type)) {
                    console.log("inside " + type)
                    await this.getBackendData(type)
                } else {
                    console.log("1")
                    this.wrongParams = true
                }
            } else {
                console.log("2")
                this.wrongParams = true
            }
            this.doneLoading = true
        },
        async getBackendData(type){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get(`api/other-details/processor?type=${type}`)
                .then(response => {
                    console.log(response.data)
                    if(response.data.status === 80){
                        this.rowHeaders = response.data.details.rowHeaders
                        this.returnData = response.data.details.returnData
                        this.tableSetup(response.data.details.rowHeaders, response.data.details.returnData)
                    }else{
                        this.wrongParams = true
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
    },
}
</script>

<style scoped>

</style>
